<template>
  <div class="vue header-vantaggi header-white py-5">
      <div class="container">

        <h1 class="mb-5" v-html="title"></h1>
        <div class="row">
          <div class="col-sm-6 text-black" v-html="body"></div>
          <div class="col-sm-3  d-flex align-items-center justify-content-start  justify-content-md-end">
<!--            <div class="py-4" v-if="coupons.length > 0 && required"><a data-aa-click='{"form" : { "click" : "PIN - NEGOZI TIM"}}' href="/pin-attivi" class="text-primary">PIN - NEGOZI TIM&nbsp;&rsaquo;</a></div>-->
          </div>
          <div class="col-sm-3 d-flex align-items-center justify-content-start  justify-content-md-end" v-html="otherLink">

          </div>
        </div>
      </div>
  </div>
</template>

<script>
import TimPartyMixin from "@/mixins/TimPartyMixin";

export default {
  name: "HeaderVantaggi",
  mixins: [ TimPartyMixin ],
  components: {},
  props: {
    title: String,
    body: String,
    otherLink: String,
    required: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      coupons: [],
    };
  },
  methods: {
    getRetrievedCoupons: function() {
      this.setApiUrl(this.user.endpoints.catalog);
      var self = this;

      var payload = {
        action: 'getRetrievedShopCoupons',
        access_token: this.accessToken,
      };

      self.loading = true;
      this.callApi( payload, function(response) {
        var coupons = [];
        for(var i in response){
          coupons.push(response[i]);
        }
        self.coupons = coupons;
      });
    }
  },
  watch: {
    user: function(){
      this.getRetrievedCoupons();
    },
  }
}
</script>
